import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TITLES: Record<string, string> = {
  '': 'Tableau de bord',
  'stats-avancees': 'Statistiques avancées',
  'mes-dossiers': 'Mes dossiers',
  'taches': 'Tâches',
  'prestations': 'Prestations',
  'nouvelle-demande': 'Nouvelle demande',
  'artistes': 'Artistes',
  'artistes-calcul': 'Calcul artistes',
  'propositions': 'Propositions',
  'contrats': 'Contrats',
  'propositions-contrats': 'Propositions & Contrats',
  // 'devis' supprimé : fusionné avec Propositions
  'facturation': 'Facturation',
  'export-comptable': 'Export comptable',
  'relances': 'Relances',
  'relances-factures': 'Relances factures',
  'agenda': 'Agenda',
  'clients': 'Clients',
  'suivi-clients': 'Suivi clients',
  'suivi-artistes': 'Suivi artistes',
  'suivi-domaines': 'Suivi domaines',
  'journal': 'Journal',
  'corbeille': 'Corbeille',
  'archives': 'Archives',
  'doublons': 'Doublons',
  'parametres': 'Paramètres',
  'utilisateurs': 'Utilisateurs',
  'roles-permissions': 'Rôles & permissions',
  'mon-compte': 'Mon compte',
  'notifications': 'Notifications',
};

export default function CrmTitle() {
  const { pathname } = useLocation();

  // Mise à jour du titre
  useEffect(() => {
    const seg = pathname.replace(/^\/crm-pro-evenementiel\/?/, '').split('/')[0] || '';
    const label = TITLES[seg] || 'CRM Pro';
    document.title = `${label} — CRM Pro Cygnature`;
  }, [pathname]);

  // Basculement du favicon vers la version CRM (foncé) à l'entrée, restauration à la sortie
  useEffect(() => {
    const selectors = 'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]';
    const originalEls = Array.from(document.querySelectorAll(selectors)) as HTMLLinkElement[];

    // Détacher les favicons du site
    originalEls.forEach((el) => el.parentNode?.removeChild(el));

    // Ajouter les favicons CRM
    const crmIcons = [
      { rel: 'icon', type: 'image/png', href: '/favicon-crm-96x96.png', sizes: '96x96' },
      { rel: 'icon', type: 'image/png', href: '/favicon-crm.png' },
      { rel: 'shortcut icon', href: '/favicon-crm.png' },
      { rel: 'apple-touch-icon', sizes: '180x180', href: '/favicon-crm-96x96.png' },
    ];

    crmIcons.forEach((attrs) => {
      const link = document.createElement('link');
      Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
      document.head.appendChild(link);
    });

    // Theme color adapté au CRM (fond slate)
    const themeMeta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null;
    const originalTheme = themeMeta?.getAttribute('content') || '#c4912a';
    if (themeMeta) themeMeta.setAttribute('content', '#0F172A');

    return () => {
      // Supprimer les favicons CRM
      document.querySelectorAll(selectors).forEach((el) => el.parentNode?.removeChild(el));
      // Restaurer les favicons originaux
      originalEls.forEach((el) => document.head.appendChild(el));
      // Restaurer la couleur thème
      if (themeMeta) themeMeta.setAttribute('content', originalTheme);
    };
  }, []);

  return null;
}
